import React, { useState } from 'react';
import './ReasonDisplay.css';

const ReasonDisplay = ({ reason, currentStyle, styles, onChangeStyle, onRegenerate, onBack }) => {
  const [showToast, setShowToast] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(reason)
      .then(() => {
        setShowToast(true);
        setTimeout(() => setShowToast(false), 1800);
      })
      .catch(err => console.error('复制失败: ', err));
  };

  return (
    <div className="reason-display-container">
      <div className="reason-card">
        <p>{reason}</p>
      </div>

      <div className="controls">
        <p>不满意？试试别的风格</p>
        <select className="style-selector" value={currentStyle} onChange={(e) => onChangeStyle(e.target.value)}>
          {styles.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
        </select>
      </div>

      <div className="action-buttons">
        <button onClick={onRegenerate}>换一个</button>
        <button onClick={handleCopy}>复制理由</button>
        <button className="back-btn" onClick={onBack}>返回重选</button>
      </div>

      {showToast && (
        <div className="snackbar-toast">理由已复制到剪贴板！</div>
      )}
    </div>
  );
};

export default ReasonDisplay;
